import {ExtendedFieldsFragment} from '../../gql/graphql';

export interface UserFieldsNamespaces {
  _user_fields: any;
}

export type ExtendedFieldNamespaces = Pick<ExtendedFieldsFragment, 'namespaces'> | UserFieldsNamespaces;

export interface UserExtendedFields {
  namespaces?: ExtendedFieldNamespaces;
}

export function isExtendedFieldNamespacesIsUserFields(
  namespaces: ExtendedFieldNamespaces
): namespaces is UserFieldsNamespaces {
  return (namespaces as UserFieldsNamespaces)._user_fields !== undefined;
}

export enum DestinationScope {
  SPECIFIC_DESTINATIONS = 'SPECIFIC_DESTINATIONS',
  WORLDWIDE = 'WORLDWIDE',
}
